module.exports = __webpack_public_path__ + "img/03_05特別審査員賞1.c45e6355.png";